import { gql } from "@apollo/client";

export const CREATE_SETTING = gql`
  mutation CreateSetting($input: CreateSettingInput!) {
    createSetting(input: $input) {
      setting {
        id
        schemaType
        authorId
        domain
        type
        data
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_SETTING = gql`
  mutation UpdateSetting($input: UpdateSettingInput!) {
    updateSetting(input: $input) {
      setting {
        id
        schemaType
        authorId
        domain
        type
        data
        createdAt
        updatedAt
      }
    }
  }
`;
